import React from "react"

import { RequestParameters } from "components/Shared/Filters/interfaces"
import { RequestHandler } from "components/Shared/RequestHandler"
import useGetSankeyFullInformation from "../../hooks/useGetSankeyFullInformation"

import SwitchingSankeyContainer from "./SwitchingSankeyContainer"
import SwitchingSankeyContainerSkeleton from "./SwitchingSankeyContainerSkeleton"
import withVisibility from "components/Shared/Hocs/withVisibility"

type SwitchingSankeyRemoteContainerProps = {
	switchingFilters: RequestParameters
	isVisible: boolean
	levelName: string
	title: string
}

const DEFAULT_DATA = {
	switchingSummarySankey: {
		profits: { nodes: [], totalSwitching: 0 },
		losses: { nodes: [], totalSwitching: 0 },
		totalSwitching: 0,
	},
}

const SwitchingSankeyContainerRemote = (
	props: SwitchingSankeyRemoteContainerProps
) => {
	const { switchingFilters, levelName = "", title = "" } = props

	const {
		data = DEFAULT_DATA,
		isLoading,
		isError,
		error,
		refetch,
	} = useGetSankeyFullInformation(switchingFilters)
	return (
		<RequestHandler
			error={error}
			isError={isError}
			isLoading={isLoading}
			skeleton={<SwitchingSankeyContainerSkeleton />}
			retry={refetch}
		>
			<SwitchingSankeyContainer
				levelName={levelName}
				data={data.switchingSummarySankey}
				treeTitle={title}
			/>
		</RequestHandler>
	)
}

export default withVisibility(SwitchingSankeyContainerRemote)
